<template>
  <div>
    <slot v-bind="{ handleClickUploadBtn, loading, maxFileSize, fileType }"></slot>
    <input
      ref="fileInput"
      type="file"
      accept="video/*"
      @change="handleFileUpload"
      style="visibility: hidden;height: 0;width: 0;"
    />
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'UploadVideo',
  props: ['value'],
  data() {
    return {
      loading: false,
      videoFile: {
        file: null,
        filename: null,
        contentType: null,
        duration: null
      },
      maxFileSize: 10,
      fileType: ['mp4']
    }
  },
  methods: {
    handleClickUploadBtn() {
      this.$refs.fileInput.click()
    },
    async handleFileUpload(event) {
      this.loading = true
      this.videoFile = {
        file: null,
        filename: null,
        contentType: null
      }
      const file = event.target.files[0]
      if (file.size > this.maxFileSize * 1000000) {
        alert(`File is too big!`)
        await this.$swal.fire({
          type: 'error',
          title: this.$t(`ไฟล์มีขนาดใหญ่เกิน ${this.maxFileSize}mb`)
        })
      } else if (
        !this.fileType.some(type => {
          return file.type.includes(type)
        })
      ) {
        await this.$swal.fire({
          type: 'error',
          title: this.$t(`นามสกุลไฟล์ไม่ถูกต้อง ${this.fileType.join(', ')}`)
        })
      } else {
        const videoFile = await this.handleFileUploadPromise(event)
        await this.handleUploadToServer(videoFile)
      }
      this.loading = false
    },
    handleFileUploadPromise(event) {
      return new Promise(resolve => {
        const file = event.target.files[0]
        const reader = new FileReader()

        reader.onload = () => {
          const video = document.createElement('video')
          video.src = URL.createObjectURL(file)

          // Listen for the video to load metadata
          video.addEventListener('loadedmetadata', function() {
            resolve({
              file: file,
              filename: file.name,
              contentType: file.type
            })
          })
        }

        // Read the selected file as a blob
        reader.readAsArrayBuffer(file)
      })
    },
    async handleUploadToServer(videoFile) {
      try {
        let form_data = new FormData()
        form_data.append('data', videoFile.file)

        delete axios.defaults.headers.common['AUTHORIZATION']
        const response = await axios.post('https://apis.psyjai.com/uploadmedia/', form_data)
        if (response.status === 200) {
          this.$emit('onChangeFile', { url: response.data.url })
        }
      } catch (error) {
        console.error(error)
        await this.$swal.fire({
          type: 'error',
          title: error.toString()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/flow/UploadVideo.vue